export default function AboutSection() {
  return (
    <section id="sobre" className="bg-[#F5F2EE] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top: Text + Images */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start mb-20">
          {/* Text */}
          <div className="w-full lg:w-1/2">
            <div className="inline-flex items-center gap-2 border border-[#026A86]/40 rounded-full px-4 py-1.5 mb-6">
              <span className="text-[#026A86] text-xs font-medium tracking-widest uppercase">
                Quem Somos
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#011820] leading-tight mb-6">
              MoveMind
              <br />
              <span className="text-[#026A86]">Consulting</span>
            </h2>
            <p className="text-[#011820]/60 text-base leading-relaxed mb-5">
              A MoveMind Consulting é uma empresa de consultoria empresarial sediada em
              Luanda, Angola, especializada em apoiar organizações a navegar os desafios
              do mercado africano com estratégia, rigor e inovação.
            </p>
            <p className="text-[#011820]/60 text-base leading-relaxed mb-8">
              A nossa equipa é composta por profissionais experientes com formação
              internacional e profundo conhecimento do contexto local, o que nos permite
              oferecer soluções verdadeiramente adaptadas à realidade angolana.
            </p>

            {/* Key facts */}
            <div className="grid grid-cols-2 gap-5">
              {[
                { icon: 'ri-map-pin-line', label: 'Sede em Luanda, Angola' },
                { icon: 'ri-global-line', label: 'Actuação em toda África' },
                { icon: 'ri-award-line', label: 'Equipa certificada internacionalmente' },
                { icon: 'ri-links-line', label: 'Parcerias estratégicas globais' },
              ].map((fact) => (
                <div key={fact.label} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#026A86]/10 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${fact.icon} text-[#026A86] text-sm`} />
                  </div>
                  <span className="text-[#011820]/70 text-sm leading-snug">{fact.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Images */}
          <div className="w-full lg:w-1/2 flex gap-4">
            <div className="w-[40%] rounded-2xl overflow-hidden h-72 md:h-96 flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/8868f0d1a343a0a634f749c3e351af72.jpeg"
                alt="Equipa MoveMind"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-[60%] rounded-2xl overflow-hidden h-72 md:h-96">
              <img
                src="https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/ae379d6be7572f2e3c158f8dda675908.jpeg"
                alt="Escritório MoveMind"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="bg-[#011820] rounded-3xl p-10 md:p-14 flex flex-col md:flex-row items-center gap-8">
          <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
            <i className="ri-double-quotes-l text-5xl text-[#026A86]" />
          </div>
          <div>
            <p className="text-white text-xl md:text-2xl font-light leading-relaxed italic mb-4">
              Acreditamos que o sonho de um novo ciclo de vida empresarial depende,
              exclusivamente, da coragem de se reinventar como organização.
            </p>
            <span className="text-[#026A86] text-sm font-semibold tracking-wide">
              — Equipa MoveMind Consulting
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
